import { Card, CardBody } from 'reactstrap'
import { SkillLabel } from '../JobDetails/Details'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { getCareerJobs } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import './style.css'

function Job() {
  const location = useLocation()
  const history = useHistory()

  const dispatch = useDispatch()
  const { careerJobs } = useSelector((store) => store.recruitment)

  useEffect(() => {
    dispatch(getCareerJobs(location?.search?.split('=')?.at(1)))
  }, [dispatch, location?.search])

  return (
    <Card>
      <CardBody>
        <div
          className='text-center mx-auto d-flex flex-column'
          style={{ gap: '1rem' }}
        >
          <span className='title'>{careerJobs?.title}</span>
          <div className='skills-container' style={{ display: 'grid' }}>
            {careerJobs?.skills?.map((skill) => (
              <SkillLabel key={skill?.id} skill={skill} />
            ))}
          </div>
          <span>
            <FontAwesomeIcon icon={faLocationDot} /> {careerJobs?.location}
          </span>
          <button
            onClick={() =>
              history.push(
                `/job/career?apply_job=${location?.search?.split('=')?.at(1)}`
              )
            }
            className='btn btn-info mx-auto'
            style={{ width: 'fit-content' }}
          >
            Apply Now <FontAwesomeIcon icon={faPaperPlane} />
          </button>
        </div>
        <div className='px-3'>
          <h2 className='mt-4 mb-3'>Requirements</h2>
          <div
            className=''
            dangerouslySetInnerHTML={{
              __html: careerJobs?.requirements,
            }}
          ></div>
          <h2 className='mt-5 mb-3'>Description</h2>
          <div
            dangerouslySetInnerHTML={{ __html: careerJobs?.description }}
          ></div>
        </div>
      </CardBody>
    </Card>
  )
}

export default Job
